var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.value)?_c('div',{staticClass:"toast d-flex align-start justify-space-between",style:({ width: _vm.width, height: _vm.height })},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }